import { useDynamicResponsiveValue } from "quickly-react";

export const useMobileScreen = () => {
  const rV = useDynamicResponsiveValue(["xs", "md"]);
  const breakpoint = rV({ xs: "xs", md: "md" });

  return breakpoint === "xs";
}
